import { render, staticRenderFns } from "./bindBedByTeacherDialog.vue?vue&type=template&id=2d3c557c&"
import script from "./bindBedByTeacherDialog.vue?vue&type=script&lang=js&"
export * from "./bindBedByTeacherDialog.vue?vue&type=script&lang=js&"
import style0 from "./bindBedByTeacherDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports